import React, { useState, useRef, useEffect } from "react";
import ChatBubble from "./ChatBubble";
import ChatPanel from "./ChatPanel";
import PropTypes from "prop-types";
import {BUBBLE_SIZE, MARGIN} from "../../constants/constants";


const ChatBot = ({ digitizationId }) => {
    const [isOpen, setIsOpen] = useState(false);
    const [isDragging, setIsDragging] = useState(false);

    // Default: bottom right
    const [position, setPosition] = useState({
        x: window.innerWidth - BUBBLE_SIZE - MARGIN,
        y: window.innerHeight - BUBBLE_SIZE - MARGIN,
    });

    const moved = useRef(false);
    const offset = useRef({ x: 0, y: 0 });

    // Keep the bubble visible when screen resizes
    useEffect(() => {
        const handleResize = () => {
            setPosition((prev) => ({
                x: Math.min(
                    prev.x,
                    window.innerWidth - BUBBLE_SIZE - MARGIN
                ),
                y: Math.min(
                    prev.y,
                    window.innerHeight - BUBBLE_SIZE - MARGIN
                ),
            }));
        };

        window.addEventListener("resize", handleResize);

        return () => {
            window.removeEventListener("resize", handleResize);
        };
    }, []);

    const handleMouseDown = (e) => {
        e.preventDefault();

        moved.current = false;
        setIsDragging(true);

        const rect = e.currentTarget.getBoundingClientRect();

        offset.current = {
            x: e.clientX - rect.left,
            y: e.clientY - rect.top,
        };

        const handleMouseMove = (event) => {
            moved.current = true;

            let x = event.clientX - offset.current.x;
            let y = event.clientY - offset.current.y;

            // Prevent leaving screen boundaries
            x = Math.max(
                MARGIN,
                Math.min(x, window.innerWidth - BUBBLE_SIZE - MARGIN)
            );

            y = Math.max(
                MARGIN,
                Math.min(y, window.innerHeight - BUBBLE_SIZE - MARGIN)
            );

            setPosition({ x, y });
        };

        const handleMouseUp = () => {
            setIsDragging(false);

            document.removeEventListener("mousemove", handleMouseMove);
            document.removeEventListener("mouseup", handleMouseUp);
        };

        document.addEventListener("mousemove", handleMouseMove);
        document.addEventListener("mouseup", handleMouseUp);
    };

    const handleClick = () => {
        if (moved.current) {
            moved.current = false;
            return;
        }

        setIsOpen(true);
    };

    return (
        <>
            {!isOpen && (
                <ChatBubble
                    onClick={handleClick}
                    onMouseDown={handleMouseDown}
                    isActive={isOpen}
                    isDragging={isDragging}
                    style={{
                        position: "fixed",
                        left: `${position.x}px`,
                        top: `${position.y}px`,
                        zIndex: 9999,
                    }}
                />
            )}

            {isOpen && (
                <ChatPanel
                    digitizationId={digitizationId}
                    onClose={() => setIsOpen(false)}
                />
            )}
        </>
    );
};

ChatBot.propTypes = {
    digitizationId: PropTypes.number,
};

export default ChatBot;